module.exports = "a{\n  color:initial;\n}\n"